import {
  ClientEmployeeFragment,
  useCreateClientEmployeeMutation,
} from "@graphql/client-employees/clientEmployees.g";

import {
  ClientEmployeeForm,
  ClientEmployeeFormValues,
} from "@components/Forms/ClientEmployeeForm/ClientEmployeeForm";

type Props = {
  clientId: string;
  onCreateClientEmployeeSuccess?: (
    data: ClientEmployeeFragment,
  ) => Promise<void> | void;
};

export const CreateClientEmployeeForm = ({
  clientId,
  onCreateClientEmployeeSuccess,
}: Props) => {
  const createClientEmployeeMutation = useCreateClientEmployeeMutation();
  const createClientEmployee = createClientEmployeeMutation.mutateAsync;

  const onSubmit = async (values: ClientEmployeeFormValues) => {
    const data = await createClientEmployee({
      input: {
        ...values,
        clientId,
      },
    });

    const clientEmployee = data?.createClientEmployee?.employee;

    if (!clientEmployee) return;

    await onCreateClientEmployeeSuccess?.(clientEmployee);
  };

  return <ClientEmployeeForm onSubmit={onSubmit} />;
};
